<script setup lang="ts">
import type { BlockGalleryFile } from '~/types';

export interface PostProjectProps {
  page: any;
}

const props = defineProps<PostProjectProps>();

const galleryItems = computed(() => {
  if (!props.page) return;
  return unref(props.page)?.gallery.map((item: BlockGalleryFile) => {
    return item.directus_files_id;
  });
});
</script>
<template>
  <div class="py-12">
    <header class="relative h-[400px] overflow-hidden flex justify-center items-center">
      <NuxtImg
        class="absolute inset-0 object-cover w-full h-full"
        :src="page?.image?.id + '?width=1000'"
        :alt="page?.image?.description ?? 'This is the projects logo'"
        :title="page?.image?.description ?? 'This is the projects logo'"
        placeholder
      />
      <div class="absolute inset-0 bg-gray-500 dark:bg-gray-900 opacity-75" />
      <div class="relative max-w-3xl p-8 mx-auto overflow-hidden bg-gray-900 bg-opacity-50 rounded-card">
        <TypographyHeadline :content="page?.title" class="text-white" size="xl" />

        <TypographyProse :content="page?.summary" class="text-white mt-4" />
      </div>
    </header>

    <BlockContainer class="md:flex gap-8">
      <!-- Main -->
      <main class="p-4">
        <article class="w-full">
          <TypographyProse ref="article" :content="page?.content" />
        </article>
        <!-- return button -->
        <UButton
          to="/projects"
          color="primary"
          variant="solid"
          class="px-4 mt-4 text-white dark:text-white"
          size="xl"
          label="Back to Projects"
          trailing-icon="material-symbols:arrow-back-rounded"
        />
        <!-- Optional Image Gallery -->
        <VGallery v-if="galleryItems && galleryItems.length > 0" :items="galleryItems" />
      </main>
      <!-- Project Metadata -->
      <aside class="md:w-[300px] flex-shrink-0">
        <div class="p-4 space-y-8 border-2 dark:border-gray-700 rounded-card">
          <div>
            <TypographyTitle>Client</TypographyTitle>
            <p class="font-bold dark:text-white">
              {{ page?.client }}
            </p>
          </div>
          <div v-if="page?.built_with">
            <TypographyTitle>Built With</TypographyTitle>
            <div v-for="(item, itemIdx) in page?.built_with" :key="itemIdx" class="mt-2">
              <UBadge size="lg" color="neutral">{{ item }}</UBadge>
            </div>
          </div>
          <div v-if="page?.cost">
            <TypographyTitle>Cost</TypographyTitle>
            <p class="font-bold dark:text-white">
              {{ page?.cost }}
            </p>
          </div>
        </div>
      </aside>
    </BlockContainer>
  </div>
</template>
